import type { Middleware } from 'redux';
import { ClientEvent, ClientEventType } from '../../hooks/useParentApi';
import { RootState } from '../../store';
import * as Actions from '../actions/app';
import * as Logging from '../actions/log';
import * as Selectors from '../selectors';

export let trackClientEvent: (event: ClientEvent) => void = () => {};
export const initialiseClientTracking = (trackClientEventHandler: (event: ClientEvent) => void) => {
    trackClientEvent = trackClientEventHandler;
};

export const middleware: Middleware =
    ({ dispatch, getState }) =>
    next =>
    action => {
        const appState: RootState = getState();

        const trackWithLogging = (
            eventType: ClientEventType,
            properties?: { [key: string]: any },
        ) => {
            // Track current items and app version on every event
            const items: Array<string> = [];
            appState.basket.basket?.products.forEach(p => {
                for (let i = 0; i < p.quantity; i++) {
                    items.push(p.productId);
                }
            });
            const basketValue = Selectors.Basket.price(appState);

            trackClientEvent({
                event: eventType,
                basket_total: basketValue,
                items: appState.basket.basket?.products.map(product => product.productId) ?? [],
                ...properties,
            });
            dispatch(
                Logging.logDebug(
                    'Track Client Event: ' +
                        {
                            event: eventType,
                            basket_total: basketValue,
                            items:
                                appState.basket.basket?.products.map(
                                    product => product.productId,
                                ) ?? [],
                            ...properties,
                        },
                ),
            );
        };

        switch (action.type) {
            case Actions.addToBasket:
                trackWithLogging('add_to_basket');
                break;
        }

        return next(action);
    };
